import React, { useState } from 'react';
import { SelectData } from "@plans-templates/select-data";
import TravelPass from '@vds/icons/travel-pass';
import { Body } from '@vds/typography';
import styled from 'styled-components';
import { Wayfinder } from "@plans/wayfinders";
import { useSelector, useDispatch } from 'react-redux';
import ReviewModal from '../../pages/ITP/ReviewModal';
import { useNavigate } from 'react-router-dom';
import { updateCart } from '../../features/devicesAndPlans/updatePlans';
import { updateSelectedPlanData, saveFailedPlanData, setConfirmationPage } from '../../features/selectedData/selectedDataReducer';
import { saveConfirmedPlanData, savePlanEffectiveDate } from '../../features/selectedData/persistantDataReducer';
import { isDesktop, isNative, isMdot, unauth, unauthItpNsaFFlag } from '../utils/globalConfig';
import FullPageLoader from '../../shared/components/Loader';
import { getErrorMessage } from '../utils/globalUtils';

const StyledDeviceDetailsDiv = styled.div`
display:flex;
align-items: center;
`
const StyledBodyDiv = styled.div`
width: ${isDesktop ? '40%' : ''}
`
const Space = styled.div`
padding-top: 12px;
`
const TileWrapper = styled.div`
li[class^='ListItem-VDS'] {
margin-bottom: 1rem;
}
`

export const GetPlanPageDetails = ({ availablePlans, planType }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { selectedDeviceDetails, planUpdatedData, failedUpdateCartData} = useSelector(state => state?.selectedReducer);
    const { confirmedPlanData,selectedDeviceDetailsUnauth,onlyCruise} = useSelector(state => state?.persistantReducer);
    const [showReviewModal, setReviewModal] = useState(false);
    const [reviewPageData, setReviewPageData] = useState();
    const [showLoader, setShowLoader] = useState(false);

    const OnReviewClick = (planObj) => {
        setReviewModal(true);
        setReviewPageData(planObj);
    }

    const CheckRemovePlan = (cruiseITP, planTypeName) => {
        if(cruiseITP && planTypeName === "PAYGO_SEA" )
        {
            return "Y";
        }
        else
        {
            return "";
        }

    }
    const CheckIsCurrentPlanMonthly = (monthly,monthlyrecurring) => {
        if((monthly ||  monthlyrecurring) && planType=='land')
        {  return "Y"; }
        else if(planType=='land')
        { return "N"; }
        else{ return ""; }
    }
    const checkIsMonthlySelected = (planId) => {
       if(planId && (planId === '1948' || planId === '1949')){
        return "Y";
       }
       else
       return "N"
    }

    const getCurrentPlanDetails = () => {
        let planDetails = {};
        if (selectedDeviceDetails?.currentPlanDetails.length > 0) {
            let planObj = selectedDeviceDetails?.currentPlanDetails.filter((plan) => plan.planType === planType)
            if (planObj.length > 0) {
                return planDetails = planObj[0];
            } else {
                return planDetails;
            }
        } else {
            return planDetails;
        }
    }

    const updateCartAPITrigger = (planDetails) => {
        setShowLoader(true);
        let payload = {
            'mtn': planDetails?.mtn,
            'features': planDetails?.featuresCart,
            'effectiveDate': planDetails?.effectiveDate
        }
        let response = updateCart(payload);
        response.then(res => {
            if (res?.data?.responseInfo?.responseCode == 0) {
                if (planDetails?.updatedPlanDetails.find((plan) => plan.currentPlan === false)) {
                    let updatedPlans = [...confirmedPlanData, planDetails];
                    if (planDetails?.effectiveDate) {
                        const updateEffectiveObj = JSON.parse(JSON.stringify(updatedPlans)).map((plan) => {
                            if (plan?.effectiveDate) {
                                plan.effectiveDate = planDetails?.effectiveDate
                            }
                            return plan;
                        })

                        updatedPlans = updateEffectiveObj;
                    }
                    dispatch(savePlanEffectiveDate(planDetails?.effectiveDate));
                    dispatch(saveConfirmedPlanData(updatedPlans));
                }

            } else {
                const { title, message } = getErrorMessage(res)
                let errorPlanPageData = JSON.parse(JSON.stringify(planDetails));
                errorPlanPageData['errorTitle'] = title?.itemValue;
                errorPlanPageData['errorMessage'] = message?.itemValue;
                dispatch(saveFailedPlanData([...failedUpdateCartData, errorPlanPageData]));
            }
            setShowLoader(false);
            navigate(-1, { replace: true })

        }).catch(err => {
            const { title, message } = getErrorMessage(err?.response)
            let errPlanPageData = JSON.parse(JSON.stringify(planDetails));
            errPlanPageData['errorTitle'] = title?.itemValue;
            errPlanPageData['errorMessage'] = message?.itemValue;
            dispatch(saveFailedPlanData([...failedUpdateCartData, errPlanPageData]));
            setShowLoader(false);
            navigate(-1, { replace: true })
        })
    }
    const redirectUaSummary = (planDetails) => {
        let updatedPlans = [...confirmedPlanData, planDetails];
        dispatch(saveConfirmedPlanData(updatedPlans));
        !onlyCruise ? navigate("/uasummary", { replace: true }) :navigate("/uasummary")
    }
    const redirectPage = () => {
        if (unauth) {
            if (unauthItpNsaFFlag && selectedDeviceDetails.skipCruiseAndFlightPlans) {
                navigate("/uaitpskipplan")
            }
            else{
                navigate("/uaitpcruiseplan")
            }
        }
        else{navigate("/itpeffectivedate", { replace: true })}
        
    }
    const onSelectButtonClick = (plan) => {
        dispatch(setConfirmationPage(true));
        let updatedPlanData = JSON.parse(JSON.stringify(planUpdatedData));

        let currentPlandetails = getCurrentPlanDetails()
        if (Object.keys(planUpdatedData).length > 0) {
            let planObj = {
                "currentPlanId": currentPlandetails?.planId,
                "newPlanId": plan?.planId,
                "currentPlanCategory": currentPlandetails?.category,
                "newPlanCategory": plan.category,
                "currentPlanName": currentPlandetails?.planName,
                "newPlanName": plan.planName,
                "planType": planType,
                "quantity": "1",
                "removePlan": CheckRemovePlan(currentPlandetails?.cruiseITP, plan?.planTypeName),
                "currentPlanMonthly": CheckIsCurrentPlanMonthly(selectedDeviceDetails?.currentPlanAsMonthly,selectedDeviceDetails.currentPlanAsMonthlyRecurring),
                "monthlyPlan":checkIsMonthlySelected(plan?.planId)
            }
            let planObj2 = {
                "currentPlanId": "",
                "newPlanId": plan?.planId,
                "currentPlanCategory": "",
                "newPlanCategory": plan.category,
                "planType": planType,
                "quantity": "1",
        }

            let plandetails =
            {
                "planName": plan?.updatedPlanName,
                "planCost": plan?.updatedPlanCost,
                "planType": planType,
                "currentPlan": plan?.currentPlan
            }

            updatedPlanData?.features?.push(planObj2);
            updatedPlanData?.featuresCart?.push(planObj);
            updatedPlanData?.featuresConfirm?.push(planObj);
            updatedPlanData?.updatedPlanDetails?.push(plandetails);

        } else {
           unauth ?
           updatedPlanData = {
            "mtn": "newLine1",
            "sorId":selectedDeviceDetailsUnauth?.sorId,
            "deviceImageUrl": selectedDeviceDetailsUnauth?.deviceImageUrl,
            "deviceImageAlt": selectedDeviceDetailsUnauth?.deviceImageAlt,
            "deviceNickName": selectedDeviceDetailsUnauth?.deviceNickName,
            "features": [
                {
                        "currentPlanId": "",
                        "newPlanId": plan?.planId,
                        "currentPlanCategory": "",
                        "newPlanCategory": plan.category,
                        "planType": planType,
                        "quantity": "1",
                }],
            
           }
           :
           updatedPlanData = {
                "mtn": selectedDeviceDetails?.mtn,
                "formattedMtn": selectedDeviceDetails?.formattedMtn,
                "deviceImageUrl": selectedDeviceDetails?.deviceImageUrl,
                "deviceImageAlt": selectedDeviceDetails?.deviceImageAlt,
                "role": selectedDeviceDetails?.role,
                "deviceNickName": selectedDeviceDetails?.deviceNickName,
                "canadaMexicoCovered": selectedDeviceDetails?.canadaMexicoCovered,
                "recommendedOfferName": selectedDeviceDetails?.planRecommendationInfo?.planName,
                "mtnHashCode": selectedDeviceDetails?.mtnHashCode,
                "unlimitedUltimateFlag": selectedDeviceDetails?.unlimitedUltimateFlag,
                "brandName": selectedDeviceDetails?.brandName,
                "operatingSystem": selectedDeviceDetails?.operatingSystem,
                "featuresCart": [
                    {
                        "currentPlanId": currentPlandetails?.planId,
                        "newPlanId": plan?.planId,
                        "currentPlanCategory": currentPlandetails?.category,
                        "newPlanCategory": plan.category,
                        "currentPlanName": currentPlandetails?.planName,
                        "newPlanName": plan.planName,
                        "planType": planType,
                        "quantity": "1",
                        "removePlan": CheckRemovePlan(currentPlandetails?.cruiseITP, plan?.planTypeName),
                        "currentPlanMonthly": CheckIsCurrentPlanMonthly(selectedDeviceDetails?.currentPlanAsMonthly,selectedDeviceDetails.currentPlanAsMonthlyRecurring),
                        "monthlyPlan":checkIsMonthlySelected(plan?.planId)
                    }
                ],
                "featuresConfirm": [
                    {
                        "currentPlanId": currentPlandetails?.planId,
                        "newPlanId": plan?.planId,
                        "currentPlanCategory": currentPlandetails?.category,
                        "newPlanCategory": plan.category,
                        "currentPlanName": currentPlandetails?.planName,
                        "newPlanName": plan.planName,
                        "planType": planType,
                        "quantity": "1",
                        "removePlan": CheckRemovePlan(currentPlandetails?.cruiseITP, plan?.planTypeName)
                    }
                ],
                "updatedPlanDetails": [
                    {
                        "planName": plan?.updatedPlanName,
                        "planCost": plan?.updatedPlanCost,
                        "planType": planType,
                        "currentPlan": plan?.currentPlan
                    }
                ]
            }
        }
        dispatch(updateSelectedPlanData(updatedPlanData));

        if (planType === 'land') {
            if (!plan.currentPlan && (plan.planTypeName === 'MONTHLY' || plan.planTypeName === 'MONTHLY_RECURRING')) {
                redirectPage();
            } else if (selectedDeviceDetails?.skipCruiseAndFlightPlans) {
                unauth ? navigate("/uaitpskipplan") : navigate("/itpskipplan", { replace: true })
            } else if (selectedDeviceDetails?.cruisePlan || selectedDeviceDetails?.inflightPlan || selectedDeviceDetails?.payAsYouGoSea) {
                unauth ? navigate("/uaitpcruiseplan") : navigate("/itpcruiseplanselection", { replace: true })
            } else {
                unauth ? redirectUaSummary(updatedPlanData) : updateCartAPITrigger(updatedPlanData)
            }
        } else {
            unauth ? redirectUaSummary(updatedPlanData) : updateCartAPITrigger(updatedPlanData)
        }
    }

    const disableSlect = (plan) => {
        let isMonthly = selectedDeviceDetails?.currentPlanDetails.filter((plan) => plan.monthlyITP === true).length > 0;
        return isMonthly && (plan?.planTypeName === "PAYGO_LAND");

    }
    const planTiles = availablePlans?.map(plan => {
        let tempObj = {};
        let buttonGroup = {};
        buttonGroup = {
            data: [
                {
                    use: "primary",
                    children: plan?.currentPlan ? plan?.currentPlanCtaLabel : plan?.ctaLabel,
                    ariaLabel: plan?.currentPlan ? plan?.currentPlanCtaLabel + 'Button' + plan.planName : plan?.ctaLabel + 'Button' + plan.planName,
                    onClick: () => { onSelectButtonClick(plan) },
                    disabled: disableSlect(plan)
                }
            ]
        }
        let label = {
            children: plan?.accountMemberText
        };
        let title = {
            children: plan?.planName,
            primitive: "h2",
            maxLines: 4
        };

        let promo = {
            icon: {
                name: "star",
                size: "small",
                color: "red"
            },
            children: plan?.planRecommendationInfo?.planRecommendationText,
            bold: true,
            primitive: "p",
            tooltip: {
                title: plan?.planRecommendationInfo?.tooltipHeading,
                children: plan?.planRecommendationInfo?.tooltipText
            }
        }

        let promoPayGo = {
            icon: {
                name: "star",
                size: "small",
                color: "red"
            },
            children: plan?.planRecommendationInfo?.planRecommendationText,
            bold: true,
            primitive: "p",

        }


        let price = {
            price: plan?.planCost ? plan.planCost : "",
            term: "none",
            hideCurrency: !plan?.planCost ? true : false,
            superscript: "",
            color: "primary",
            width: "105px"
        }

        price.sublockups = [
            {
                price: "",
                hideCurrency: true,
                term: "none",
                trailingText: {
                    children: plan?.costText,//<span style={{ textAlign: 'end', fontSize: '12px', lineHeight: '16px' }}>{plan?.costText}</span>,

                },
                size: "2XSmall"
            }]

        let textLink = {
            ariaLabel: plan.planName + 'ReviewPlanLink',
            children: plan?.reviewLinkText,
            href: undefined,
            target: undefined,
            onClick: () => { OnReviewClick(plan) }
        }
        let subtitle = {
            children: <><span dangerouslySetInnerHTML={{ __html: plan?.planDescription }}></span></>,
            width: "100%"
        }

        let subtile = {
            savingsText: "",
            children: ""
        }

        subtile.list = plan?.availableFeatures?.map(item => {
            let obj = {};
            let children = <><span dangerouslySetInnerHTML={{ __html: item?.text }}></span></>;
            let icon = {
                name: item?.icon,
                color: 'red'
            }
            obj.children = children;
            obj.icon = icon;

            return obj;
        })

        tempObj.title = title;
        tempObj.subtitle = subtitle;
        tempObj.textLink = textLink;
        tempObj.price = price;
        tempObj.promo = plan?.planRecommendationInfo?.payGoOnlyRecommended ? promoPayGo : plan?.planRecommendationInfo?.recommendationAvailable ? promo : '';
        tempObj.subtile = subtile;

        if (!plan?.accountMember) {
            tempObj.buttonGroup = buttonGroup;
        }
        else {
            tempObj.label = label;
        }
        return tempObj;
    })

    const dataTileGroupMaxWidth = !(isMdot || isNative) ? (availablePlans?.length == 1 ? "33.33%" : availablePlans?.length == 2 ? "66.66%" : "100%") : "";
    return (
        <>
            <TileWrapper>
                <SelectData tiles={planTiles} theme='monarch' dataTileGroupMaxWidth={dataTileGroupMaxWidth} />

                {showReviewModal &&
                    <ReviewModal
                        setReviewModal={setReviewModal}
                        showReviewModal={showReviewModal}
                        PlanData={reviewPageData}
                    />
                }
            </TileWrapper>
            {showLoader && <FullPageLoader />}
        </>
    );
}

export const GetHelperText = ({ subHeadingText }) => {
    return (
        <StyledDeviceDetailsDiv>
            <TravelPass
                color="#0089EC"
                size="45px"
            />
            <StyledBodyDiv>
                <Body size='large' weight='400'>{subHeadingText}</Body>
            </StyledBodyDiv>
        </StyledDeviceDetailsDiv>
    );
}

export const GetFooterNotes = ({ footerNotes }) => {

    return (
        footerNotes?.map((footNote) => (
            <Body size="small">
                {footNote?.value}
                <Space></Space>
            </Body>
        ))
    );
}
const StyledTitle = styled.div`
overflow: hidden;
white-space: normal;
text-overflow: ellipsis;
width: 100%;
`

export const GetSelectedDeviceDetails = ({ planType }) => {
    const navigate = useNavigate();
    const {onlyCruise} = useSelector(state => state?.persistantReducer);
    const onLeftArrowClick = () => {
        if (unauth) {
            if (planType == 'land') {
                navigate(-1, { replace: true });
            }
            if (planType == 'skip') {
                navigate(-2, { replace: true });
            }
            if (planType == 'sea') {
                if (onlyCruise)
                    navigate(-1, { replace: true });
                else
                    navigate(-2, { replace: true });
            }
        }
        //auth
        else {
            navigate(-1, { replace: true });
        }
    }



    let { selectedDeviceDetails } = useSelector(state => state?.selectedReducer);
    const buttonIcon = {
        ariaLabel: 'leftArrowClick',
        icon: {
            name: "left-arrow",
        },
        onClick: () => { onLeftArrowClick() }
    }

    const title = {
        children: <StyledTitle>{selectedDeviceDetails?.deviceNickName}</StyledTitle>
    }

    const subtitle = {
        children: selectedDeviceDetails?.formattedMtn
    }

    const image = {
        src: selectedDeviceDetails?.deviceImageUrl,
        alt: selectedDeviceDetails?.deviceImageAlt
    }

    return (
        <>
            <Wayfinder title={title} subtitle={subtitle} image={image} buttonIcon={buttonIcon} showButton={true} />
        </>
    );
}